import { Box, styled } from '@mui/material';

const StatusCellBox = styled(Box)`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export default StatusCellBox;
